import { EmptyObject } from 'type-fest'

/**
 * Defines strong types for feature flags, such that whenever the given key is used
 * the variables will be typed appropriately to its value.
 *
 * If a Feature Flag does not have variables, use `EmptyObject`.
 */
export interface FeatureFlags {
  buy_plan_page: Record<'ENTERPRISE' | 'FREE' | 'PRO' | 'PRO_FLEX' | 'PRO_PLUS', string>
  pricing_plan_group: { group: string }
  enable_geo_smart_rules: EmptyObject
  new_payment_methods: boolean
}

export const HIDE_LOGGED_OUT_CODE_GENERATOR_FILE_FIELDS =
  'hide_logged_out_code_generator_file_fields'
export const GENERATOR_GOOGLE_SSO_REDIS = 'generator_google_sso_redis'
export const NEW_AUTH_REDIRECT_PAGES = 'new_auth_redirect_pages'
export const STARTER_KIT_LANDING_PAGE = 'starter_kit_landing_page'
export const GOOGLE_SHEETS_AUTHORIZATION = 'google_sheets_authorization'
export const DISPLAY_VIDEO_TOOL_LINK = 'video_tools_link'
export const DISPLAY_FLOW_LEADS_LINK = 'flow_leads_link'
export const DISPLAY_VIDEO_TOOLS_SINGLE_LINK = 'video_tools_single_link'
export const KLAVIYO_CRM_INTEGRATION = 'klaviyo_crm_integration'
export const HUBSPOT_CRM_INTEGRATION = 'hubspot_crm_integration'
export const ENABLE_BOISE_STATE_SSO = 'sso_boise_state'
export const ENABLE_KRAFT_HEINZ_SSO = 'sso_kraft_heinz'
export const ENABLE_PRINCE_WILLIAM_COUNTY_SSO = 'sso_prince_william_county'
export const ENABLE_LIBERTY_MUTUAL_SSO = 'sso_liberty_mutual'
export const ENABLE_UPGRADE_NAV_LINK = 'upgrade_to_checkout_test'
export const FLOWTAG_LANDING_ENABLED = 'flowtag_landing'
export const FLOWPAGE_GENERATOR_WITH_PREVIEW = 'flowpage_generator_with_preview'
export const CUSTOM_CODE_PROMO_TILE = 'custom_code_promo_tile'
export const SALESFORCE_CRM_INTEGRATION = 'salesforce_crm_integration'
export const ENABLE_SHOPPING_CART_DYNAMIC_SHIPPING = 'enable_shopping_cart_dynamic_shipping'
export const TEMPLATES_STORE_VARIANTS = 'templates_store_variants'
export const GEOLOCATION_INTERSTITIAL = 'geolocation_interstitial'
export const ENABLE_MERGED_STORE_FLOWTAG_BTM_BANNER = 'enable_merged_store_flowtag_btm_banner'
export const GLOBAL_SEARCH_BAR = 'global_search_bar'
export const DISABLE_AUTO_DESIGN_LOGO_RESIZE = 'disable_auto_design_logo_resize'
export const DISABLE_AUTO_LOGO_RESIZE = 'disable_auto_logo_resize'
export const EDIT_FLOWCODE_DESIGN_V2 = 'edit_flowcode_design_v2'
/*
  Customizations Options for FC & FP Q2 2022
  See. https://app.shortcut.com/flowcode/epic/42676/customization-updates-and-additions
*/

/*
  Flowpage Link- and Page- level styling customization
  See. https://app.shortcut.com/flowcode/epic/45515/flowpage-link-level-styling
*/
export const FLOWPAGE_LINK_LEVEL_STYLE_CUSTOMIZATION = 'flowpage_link_level_style_customization'
export const FP_RICH_TEXT_BOX_SECTION = 'rich_text_box_section'
export const CRM_FORMS = 'crm_forms'
export const BUNDLES = 'bundles'
export const VIEW_LIVE_FORM_RESULTS = 'view_live_form_results'
export const DAILY_FORM_SUMMARIES = 'daily_form_summaries'
export const CRM_VIEW_SUBMISSIONS = 'crm_view_submissions_page'
export const SELF_SERVICE_UPGRADE_TO_PROFLEX = 'self_service_upgrade_to_proflex'
export const TRANSFER_FOLDER = 'transfer_folder'
export const MOBILE_SIMPLIFIED_SITE_NAVIGATION = 'simplified_mobile_site_navigation_q1_2023'
export const TEMPLATES_ENTRY_POINT = 'templates_entry_point'
export const DESKTOP_SIMPLIFIED_SITE_NAVIGATION = 'simplified_desktop_site_navigation_q1_2023'
export const UNIFIED_DISCOVER_TEMPLATES = 'unified_discover_templates'
export const UNIFIED_YOUR_TEMPLATES = 'unified_your_templates'
export const DISPLAY_UNIFIED_TEMPLATES_NEW_LABEL = 'display_unified_templates_new_label'
export const UNIFIED_ASSET_MANAGEMENT = 'unified_asset_management_q2_2023'
export const ATLAS_FEATURE_FLAG = 'atlas'
export const BRAND_KIT = 'enable_brand_kit'
export const TEXT_FLOWCODE = 'text_flowcode'
